import React from 'react';
import './StatusBanner.css';

const StatusBanner = ({ onImport, buttonText, messageText, bannerImage = "/images/components/status-banner.svg" }) => {
  return (
    <div className="status-banner">
      <div className="status-banner-content">
        <div className="status-banner-left">
          <div className="icon-container">
            <img src={bannerImage}  />
          </div>
          <span style={{fontSize: 16}}>{messageText}</span>
        </div>
        {onImport && buttonText && (
          <button 
            className="import-button" 
            onClick={onImport}
          >
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default StatusBanner;
